import { Injectable } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { UnitsModel } from '../models/units';
import { ToastClientService } from "../../../services/toast/toast-client.service";

@Injectable({
  providedIn: 'root'
})
export class UnitsProvider {

  units: UnitsModel[] = [];

  constructor(
    private apiService: ApiService,
    private toast: ToastClientService,
    private apiConfig: ApiConfiguration
  ) {
  }

  getUnitsList(): void {
    if (this.units.length == 0) {
      this.apiService.getHeaders(this.apiConfig.configGetUnit).subscribe(
        (res: any) => {
          this.units = res.body.data as UnitsModel[];
        }
      );
    }
  }

  unitAdd(formData: UnitsModel) {
    let apiUrl = this.apiConfig.configAddUnit;
    this.apiService.post(apiUrl, formData).subscribe(
      (res: any) => {
        formData.id = res.body.data.id;

          this.units.push(formData); 
        
        this.units.forEach(b => {
          //  if(formData.region_name && b.id == formData.id) {
          //    b.region_name = formData.region_name;
          //  }
        })

        this.toast.Success(res.body.data.message);
      },
      (err) => { 
        console.log("err", err);
      }
    );
  }

  unitEdit(formData: UnitsModel) {

    let apiUrl = this.apiConfig.configEditUnit + formData.id;

    this.apiService.put(apiUrl, formData)
      .subscribe((res: any) => {
        let updateIndex = this.units.findIndex(item => item.id == formData.id);
        this.units[updateIndex].unit_name = formData.unit_name;
        this.units[updateIndex].unit_desc = formData.unit_desc;
        this.toast.Success(res.body.data.message);
      },
        (err) => {
          console.log("err", err);
        }
      );
  }

  unitDelete(formData: UnitsModel) {
    let apiUrl = this.apiConfig.configEditUnit + formData.id;
    this.apiService.put(apiUrl, formData)
      .subscribe((res: any) => {
        let updateIndex = this.units.findIndex(item => item.id == formData.id);
        this.units.splice(updateIndex, 1);
        this.toast.Success(res.body.data.message);
      },
        (err) => {
          console.log("err", err);
        }
      );
  }
}
